import Gracenote from './Gracenote';

export default new Gracenote();
